
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCompanies, getDonationCart, getMyMarketPlace } from "@/helpers/server-actions/market-place-collection";
import { Cart, Company } from "@/models/marketPlace";

interface MarketPlaceState { 
    companies: Company[];
    cart: Cart[];
    myMarketPlaces: Company[];
    loading: boolean;
}

const initialState: MarketPlaceState = { 
    companies: [],
    cart: [], 
    myMarketPlaces: [],
    loading: false,
};

// create async thunk to fetch companies
export const fetchCompanies = createAsyncThunk(
    "marketPlace/fetchCompaniesData",
    async () => {
        const response = await getCompanies(); 
        return response;
    }
);

// create async thunk to fetch cartData
export const fetchCartData = createAsyncThunk(
    "marketPlace/fetchCartData",
    async (userId: string) => {
        const response = await getDonationCart(userId); 
        return response;
    }
);

export const fetchMyMarketPlace = createAsyncThunk(
    "marketPlace/fetchMyMarketPlaceData",
    async (userId: string) => { 
        const response = await getMyMarketPlace(userId);
        return response;
    }
);


const marketPlaceSlice = createSlice({
    name: "marketPlace",
    initialState,
    reducers: { 
        resetState: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCompanies.fulfilled, (state, action) => {
            state.companies = action.payload;
            state.loading = false;
        });
        builder.addCase(fetchCompanies.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchCompanies.rejected, (state) => {
            state.loading = false;
        });

        builder.addCase(fetchCartData.fulfilled, (state, action) => {
            state.cart = action.payload;
            state.loading = false;
        });
        builder.addCase(fetchCartData.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchCartData.rejected, (state) => {
            state.loading = false;
        });

        builder.addCase(fetchMyMarketPlace.fulfilled, (state, action) => {
            state.myMarketPlaces = action.payload;
            state.loading = false;
        });
        builder.addCase(fetchMyMarketPlace.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchMyMarketPlace.rejected, (state) => {
            state.loading = false;
        });
        
    },
});

export const { resetState } = marketPlaceSlice.actions;
 
export default marketPlaceSlice.reducer;